import { render, staticRenderFns } from "./MainProgram.vue?vue&type=template&id=df5c959c&scoped=true"
import script from "./MainProgram.vue?vue&type=script&lang=js"
export * from "./MainProgram.vue?vue&type=script&lang=js"
import style0 from "./MainProgram.vue?vue&type=style&index=0&id=df5c959c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df5c959c",
  null
  
)

export default component.exports